/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { jiraIssueTypeModelSchema } from './jiraIssueTypeModelSchema';
import { jiraStatusModelSchema } from './jiraStatusModelSchema';

export const jiraProjectTypesAndStatusesModelSchema = z.object({
  get issueTypes() {
    return z.array(jiraIssueTypeModelSchema);
  },
  get statuses() {
    return z.array(jiraStatusModelSchema);
  },
});
